import { schema } from "normalizr";

export const assessmentAnswerSchema = new schema.Entity("assessmentAnswers");
